import React from 'react';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';

export interface ActionTooltipProps {
  content?: React.ReactNode;
  children: React.ReactElement;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  delayDuration?: number;
  className?: string;
  disabled?: boolean;
}

/**
 * Standardized end-user Action Tooltip for desktop/hover interfaces.
 *
 * Requirements:
 * - Progressive enhancement on devices with hover/keyboard focus.
 * - Concise, plain-language description explaining the action outcome.
 * - Inert on touch/mobile devices without altering normal click/tap workflows.
 * - No critical information may exist ONLY in a tooltip.
 */
export const ActionTooltip: React.FC<ActionTooltipProps> = ({
  content,
  children,
  side = 'top',
  align = 'center',
  delayDuration = 250,
  className,
  disabled = false,
}) => {
  if (!content || disabled) {
    return children;
  }

  return (
    <Tooltip delayDuration={delayDuration}>
      <TooltipTrigger asChild>
        {children}
      </TooltipTrigger>
      <TooltipContent side={side} align={align} className={className}>
        {content}
      </TooltipContent>
    </Tooltip>
  );
};
